import { makePostRequest } from 'owa-ows-gateway';
import { PremiumExperienceType } from '../store/premiumTravelStore';

const GET_USER_PREMIUM_EXPERIENCETYPE_URL: string = 'ows/api/v1/PremiumUserExperience';
let getPremiumUserExperiencePromise: Promise<PremiumExperienceType>;

export async function getPremiumUserExperienceType(
    currentFlights: string[]
): Promise<PremiumExperienceType> {
    if (!getPremiumUserExperiencePromise) {
        let requestBody = currentFlights;
        getPremiumUserExperiencePromise = makePostRequest(
            GET_USER_PREMIUM_EXPERIENCETYPE_URL,
            requestBody
        );
    }
    return getPremiumUserExperiencePromise;
}
